import React from "react";
import { useLocation } from "react-router-dom";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

import { InputTextFieldEquip } from "../Parts/InputText";
import { InputSelectEquip } from "../Parts/InputSelect";
import { InputDateEquip } from "../Parts/InputDate";
import { InputZipCode } from "../Parts/InputZipCode";
import { EQUIPMENT } from "../Parts/Word";

import GenericTemplate from "../GenericTemplate";

const E0 = () => {
  const location = useLocation();

  return (
    <GenericTemplate type={"建築設備"} selectedIndex={location.pathname}>
      <Box
        component="form"
        sx={{
          width: "100%",
          maxWidth: "100%",
        }}
        noValidate
        autoComplete="off"
      >
        <div>
          <Grid container alignItems="center" spacing={2} sx={{ mb: 1 }}>
            <Grid item xs={2}>
              台帳番号
            </Grid>
            <Grid item xs={2}>
              <InputSelectEquip
                key_num={"e01_i1"}
                items={["A", "B", "C", "F", "G", "H"]}
              />
            </Grid>
            <Grid item xs={1} textAlign="center" sx={{ fontSize: 40 }}>
              -
            </Grid>
            <Grid item xs={7}>
              <InputTextFieldEquip key_num={"e01_i2"} />
            </Grid>
            <Grid item xs={2}>
              施設名称
            </Grid>
            <Grid item xs={7}>
              <InputTextFieldEquip key_num={"e01_ro1"} />
            </Grid>
            <Grid item xs={1}>
              棟数
            </Grid>
            <Grid item xs={2}>
              <InputSelectEquip
                key_num={"e01_ro2"}
                items={[
                  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
                  19, 20,
                ]}
              />
            </Grid>
            <Grid item xs={2}>
              報告者氏名
            </Grid>
            <Grid item xs={10}>
              <InputTextFieldEquip key_num={"e01_ha"} />
            </Grid>
          </Grid>
          <Grid container alignItems="center" spacing={2} sx={{ mb: 1 }}>
            <Grid item xs={2}>
              検査者氏名
            </Grid>
            <Grid item xs={10}>
              <InputTextFieldEquip key_num={"e01_ni"} />
            </Grid>
          </Grid>
          <Grid
            container
            alignItems="center"
            spacing={2}
            sx={{ mb: 1, borderBottom: 1 }}
          >
            <Grid item xs={2} sx={{ mb: 3 }}>
              報告年月日
            </Grid>
            <Grid item xs={10} sx={{ mb: 3 }}>
              <InputDateEquip
                key_num1={"e01_ho_1"}
                placeholderText={"報告年月日"}
              />
            </Grid>
          </Grid>
          <Grid container alignItems="center" spacing={2} sx={{ mb: 1 }}>
            <Grid item xs={12}>
              返却先
            </Grid>
          </Grid>
          <Grid container alignItems="center" spacing={2} sx={{ mb: 1 }}>
            <Grid item xs={2}>
              郵便番号
            </Grid>
            <Grid item xs={10}>
              <InputZipCode
                key_num={"e02_i1"}
                target_key_num={"e02_i2"}
                type={EQUIPMENT}
                label={"〒"}
                page={"e0"}
              />
            </Grid>
            <Grid item xs={2}>
              住所
            </Grid>
            <Grid item xs={10}>
              <InputTextFieldEquip key_num={"e02_i2"} />
            </Grid>
          </Grid>
          <Grid
            container
            alignItems="center"
            spacing={2}
            sx={{ mb: 1, borderBottom: 1 }}
          >
            <Grid item xs={2}>
              法人名
            </Grid>
            <Grid item xs={10}>
              <InputTextFieldEquip key_num={"e02_ro1"} />
            </Grid>
            <Grid item xs={2} sx={{ mb: 3 }}>
              氏名
            </Grid>
            <Grid item xs={10} sx={{ mb: 3 }}>
              <InputTextFieldEquip key_num={"e02_ro2"} />
            </Grid>
          </Grid>
          <Grid container alignItems="center" spacing={2} sx={{ mb: 1 }}>
            <Grid item xs={12}></Grid>
          </Grid>
          <Grid
            container
            alignItems="center"
            spacing={2}
            sx={{ mb: 1, borderBottom: 1 }}
          >
            <Grid item xs={2} sx={{ mb: 3 }}>
              報告先
            </Grid>
            <Grid item xs={10} sx={{ mb: 3 }}>
              <InputTextFieldEquip key_num={"e91_1"} page={"e9"} />
            </Grid>
          </Grid>
        </div>
      </Box>
    </GenericTemplate>
  );
};

export default React.memo(E0);
